module.exports = __webpack_public_path__ + "static/media/SquareBlack.411ec2c3.png";